import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading, NavParams, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ecomUserApi } from '../../../api/ecom/ecomUserApi';
import { RegisterPage, BadgesPage } from '../../../pages/pages';
import { LoginModel } from '../../../api/swagger/ecomApi';
import {ApiConfig} from '../../../shared/api-config.service'
import {AppConfig} from '../../../shared/app-config.service'
import {LoggerService} from '../../../shared/logger.service'
import {GlobalErrorService} from '../../../shared/global-error.service'
import { Storage } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

declare var Instascan: any;

@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
    providers: [ecomUserApi, ApiConfig, LoggerService,AppConfig, GlobalErrorService, BarcodeScanner]
  })

  export class LoginPage  {
    loginForm: FormGroup;
    loading: Loading;
    submitAttempt: boolean = false;
    showFailed: boolean = false;
    showMessage: boolean = false;
    showLogout: boolean = false;
    loginPanel: boolean = false;
    scanningReady: boolean = false;

    constructor(
      public navParams: NavParams,
      private navCtrl: NavController, 
      private ecomUserApi: ecomUserApi, 
      private formBuilder: FormBuilder, 
      private errorCtrl: GlobalErrorService,
      private alertCtrl: AlertController,
      private log: LoggerService,
      private loadingCtrl: LoadingController,
      public storage: Storage,
      private iab: InAppBrowser,
      private barcodeScanner: BarcodeScanner
    )        
    {
      this.showMessage = this.navParams.data;

      this.loginForm = this.formBuilder.group({
        email: ['', Validators.compose([Validators.required, Validators.email])],
        password: ['', Validators.compose([Validators.required])]
      });

      setTimeout(() =>{ 
        this.scanningReady = true;
      }, 2000);
    }

    ngOnInit(){
      this.triggerDeepLink();
    }

    triggerDeepLink() {
      var code = this.navParams.get("code");
      if (code != null && code != undefined) {
        try{
          console.log(atob(code));
        var decryptedCode = JSON.parse(atob(code));
        console.log(decryptedCode);
        let loader = this.loadingCtrl.create();
            loader.present().then(()=>{
              this.ecomUserApi.saveLoginToken(decryptedCode);
                if (decryptedCode.Token != null) {
                  this.showLogout = true;
                  this.navCtrl.setRoot(BadgesPage);
                  loader.dismiss();
                }
                else{
                  this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
                  loader.dismiss();
                  this.logout();
                }
              });
            } catch (e) {
              alert(JSON.stringify(e));
            }
      }else{

      }
     }
  
    ionViewDidLoad() {
      if(this.showMessage == true){
        this.errorCtrl.presentToast("Your registration was successful, please login using the details you just created.");
      }
    }

    qrCodeScan(){
      console.log("starting scan...");
      let scanner = new Instascan.Scanner({ video: document.getElementById('preview') });
      scanner.addListener('scan', (content) => {
        var decryptedCode = JSON.parse(atob(content));
        let loader = this.loadingCtrl.create();
            loader.present().then(()=>{
              this.ecomUserApi.saveLoginToken(decryptedCode);
                if (decryptedCode.Token != null) {
                  this.showLogout = true;
                  this.navCtrl.setRoot(BadgesPage);
                  loader.dismiss();
                }
                else{
                  this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
                  loader.dismiss();
                  this.logout();
                }
              });
      });
      Instascan.Camera.getCameras().then((cameras) => {
        if (cameras.length > 0) {
          scanner.start(cameras[0]);
        } else {
          let loader = this.loadingCtrl.create();
            loader.present().then(()=>{
              this.errorCtrl.presentToast("No camera detected...");
                  loader.dismiss();
                  this.logout();
            });
        }
      }).catch(function (e) {
        console.error(e);
      });
    }

    goToRegister(){
      this.navCtrl.push(RegisterPage);
    }

    public showLoading() {
        this.loading = this.loadingCtrl.create();
        this.loading.present();        
    }

    ForgottenPassword(){
      this.iab.create("https://enetbadges.com/Account/ForgotPassword", "_system");
    }

    public loginToApp(){
      let loader = this.loadingCtrl.create();
          loader.present().then(()=>{
            var loginModel = new LoginModel({
              userName: this.loginForm.value.email,
              password: this.loginForm.value.password
            });
            this.ecomUserApi.Login(loginModel).subscribe(
              loginResult => {
                this.ecomUserApi.saveLoginToken(loginResult);
                if(loginResult.token != null){
                  this.showLogout = true;
                  this.navCtrl.setRoot(BadgesPage);
                  loader.dismiss();
                }
                else{
                  this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
                  loader.dismiss();
                  this.logout();
                }
            },
            error => {
              this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
              this.log.error(error);              
              loader.dismiss();
            }
          )
          });
    }

    logout() {
      let loader = this.loadingCtrl.create();
      loader.present().then(() => {
        this.storage.remove('username');
        this.storage.remove('accessToken');
        this.navCtrl.setRoot(LoginPage);
        loader.dismiss().catch(err => console.log(err));
      }).catch(
        function (error) {
          loader.dismiss().catch(err => console.log(err))
        });
    }

    loginSave(){
        this.submitAttempt = true;
        if(this.loginForm.valid){
            this.loginToApp();
        }
    }

  }


// WEBPACK FOOTER //
// ./src/pages/authorization/login/login.ts